import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { useAlert } from 'react-alert';
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import WhiteCheckmark from "../../../../../../../assets/images/researcher_app/overview/white_checkmark_larger.svg";
import { PrimaryButton, SecondaryButton } from "../../common_components/Buttons";
import { Card, RightAlignedButton } from "../../common_components/Layout";

import LightbulbIcon from "../../../../../../../assets/images/researcher_app/create/survey_lightbulb_icon.png"
import SurveyIcon from "../../../../../../../assets/images/researcher_app/create/survey_icon.png"


function SurveyDetailCard(props) {
    const alert = useAlert();
    const navigate = useNavigate();
    const { missionId } = useParams()

    const isScreener = props.isScreener;
    const instructionsText = isScreener ?
        "We recommend including five or fewer questions in your screener survey."
        :
        "Survey price is based on the total number of questions. Issues? Contact us at info@despark.io."
    const noSurveyCallout = isScreener ? "This project does not have a screener survey yet." : "This project does not have a survey yet."
    const createButtonText = isScreener ? "Create Screener" : "Create Survey"
    const editButtonText = isScreener ? "Edit Screener" : "Edit Survey"
    const navigateUrl = getNavigateUrl(isScreener, missionId)
    const returnUrl = isScreener ? `/createmission/${missionId}/screener` : `/createmission/${missionId}/survey`
    const cardTitle = "Question List"

    const createButton = props.alertButton ?
        <SecondaryButton text={createButtonText} onClick={() => alert.show("Can't edit after launch (yet). Need to adjust? Email us at info@despark.io", { type: "error" })} />
        :
        <PrimaryButton text={createButtonText} onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />

    const editButton = props.alertButton ?
        <SecondaryButton text={editButtonText} onClick={() => alert.show("Can't edit after launch (yet). Need to adjust? Email us at info@despark.io", { type: "error" })} />
        :
        <PrimaryButton text={editButtonText} onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />


    return (
        <div className="screener-highlight-card" style={props.cardStyle}>
            {props.loadingSurvey ? <CenteredLoadingIcon /> :
                <>{
                    props.questionCount === 0 ?
                        <>
                            <div className="screener-text-holder">
                                <div className="screener-text">
                                    {instructionsText}
                                </div>
                                <div className="screener-callout-badge">
                                    {noSurveyCallout}
                                </div>
                            </div>
                            <div></div>
                            <RightAlignedButton>
                                {createButton}
                            </RightAlignedButton>
                        </>
                        :
                        <>
                            <div className="screener-title-row">
                                <div className="screener-title">{cardTitle}</div>
                                {isScreener && <div className="screener-title right">Includes (in)correct answers?</div>}
                            </div>
                            <div className="screener-question-list-container">
                                <MappedRows surveyQuestions={props.surveyQuestions} questionCount={props.questionCount} showScreener={isScreener} />
                            </div>
                            {isScreener && props.questionCount > 5 ?
                                <div className="screener-callout-badge">
                                    We recommend including 5 or fewer questions.
                                </div>
                                : <div />
                            }
                            <RightAlignedButton>
                                {editButton}
                            </RightAlignedButton>
                        </>
                }</>}
        </div>
    )
}

function MappedRows(props) {
    return props.surveyQuestions.map((question, index) => {
        if (index > 5) return (null)
        if (index == 5) return (<div key={props.showScreener ? "screener-tail-note" : "survey-tail-note"} className="screener-tail-note">... and {props.questionCount - 5} more question(s)</div>)
        const screenerKeyNote = props.showScreener ? "screener" : "survey"
        return (
            <SurveyQuestionRow key={screenerKeyNote + "row" + index} index={index} text={question.title} type={question.type} showScreener={props.showScreener} screenerLogic={question.containsScreenerLogic} bottomBorder={index + 1 < props.surveyQuestions.length} />
        )
    })
}

function SurveyQuestionRow(props) {
    const rowClass = props.bottomBorder ? "screener-question-row" : "screener-question-row no-border"
    const questionText = props.type == "image" ? "(Image displayed)" : props.text

    return (
        <div key={props.index} className={rowClass}>
            <div className="screener-question-number-and-title">
                <div className="screener-question-number">{props.index + 1}.</div>
                <div className="screener-question-table-text">{questionText}</div>
            </div>
            {props.showScreener && props.screenerLogic ?
                <div className="purple-screener-answer-text" >
                    (Correct Answer Required)
                </div>
                :
                props.showScreener ?
                    <div className="screener-no-checkmark">No</div>
                    : <></>
            }
        </div>

    )
}

function EmptySurveyDetailCard(props) {
    const navigate = useNavigate();
    const { missionId } = useParams()
    const navigateUrl = getNavigateUrl(props.isScreener, missionId)
    const returnUrl = props.isScreener ? `/createmission/${missionId}/screener` : `/createmission/${missionId}/survey`

    const titleText = props.isScreener ? "This mission does not have screener questions yet." : "This mission does not have a survey yet."
    const buttonText = props.isScreener ? "Create screener" : "Create survey"

    return (
        <div className="empty-survey-card-outline">
            <img src={LightbulbIcon} height={46} width={46} />
            <div className="empty-survey-card-content-div" >
                <div className="empty-survey-card-text-div">
                    <div className="empty-survey-title-text">
                        {titleText}
                    </div>
                    <div className="empty-survey-card-text">
                        {props.isScreener ?
                            "Screener questions help you filter out respondents who don't meet your criteria."
                            :
                            <>Create your survey. The price is based on the total number of questions. Issues with the survey or price? Contact us at <span className="purple-highlight-text">info@despark.io.</span></>
                        }
                    </div>
                </div>
                <PrimaryButton text={"+   " + buttonText} onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />
            </div>

        </div>
    )
}

function NewSurveyDetailCard(props) {
    const alert = useAlert();
    const navigate = useNavigate();
    const { missionId } = useParams()

    const isScreener = props.isScreener;
    const instructionsText = isScreener ?
        "We recommend including five or fewer questions in your screener survey."
        :
        "Survey price is based on the total number of questions. Issues? Contact us at info@despark.io."
    const noSurveyCallout = isScreener ? "This project does not have a screener survey yet." : "This project does not have a survey yet."
    const createButtonText = isScreener ? "Create Screener" : "Create Survey"
    const editButtonText = isScreener ? "Edit Screener" : "Edit Survey"
    const navigateUrl = getNavigateUrl(isScreener, missionId)
    const returnUrl = isScreener ? `/createmission/${missionId}/screener` : `/createmission/${missionId}/survey`
    const cardTitle = "Question List"

    const createButton = props.alertButton ?
        <SecondaryButton text={createButtonText} onClick={() => alert.show("Can't edit after launch (yet). Need to adjust? Email us at info@despark.io", { type: "error" })} />
        :
        <PrimaryButton text={createButtonText} onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />

    const editButton = props.alertButton ?
        <SecondaryButton text={editButtonText} onClick={() => alert.show("Can't edit after launch (yet). Need to adjust? Email us at info@despark.io", { type: "error" })} />
        :
        <PrimaryButton text={editButtonText} onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />


    return (
        <div className="screener-highlight-card" style={props.cardStyle}>
            {props.loadingSurvey ? <CenteredLoadingIcon /> :
                <>{
                    props.questionCount === 0 ?
                        <EmptySurveyDetailCard isScreener={isScreener} />
                        :
                        <>
                            <div className="screener-title-row">
                                <div className="screener-title-icon-and-text">

                                    <img src={SurveyIcon} height={34} width={34} />
                                    <div className="screener-title">Question List</div>
                                </div>
                                {isScreener && <div className="screener-title right">Includes (in)correct answers?</div>}
                                {/* This exists because we want to put the header of the screening logic? column here for screeners. */}
                                {/* The createmission screener section uses a different class. But the survey section in createmission looks bad with the button onbottom. */}
                                {!isScreener && <PrimaryButton text={editButtonText} onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />}
                            </div>
                            <div className="screener-question-list-container">
                                <MappedRows key={isScreener ? "screener-rows" : "survey-rows"} surveyQuestions={props.surveyQuestions} questionCount={props.questionCount} showScreener={isScreener} />
                            </div>
                            {isScreener &&
                                <RightAlignedButton>
                                    <PrimaryButton text={editButtonText} onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />
                                </RightAlignedButton>
                            }
                        </>
                }</>}
        </div>
    )
}

function getNavigateUrl(isScreener, missionId) {
    return isScreener ? `/missions/${missionId}/screener` : `/missions/${missionId}/survey`
}


export { SurveyDetailCard, EmptySurveyDetailCard, NewSurveyDetailCard, MappedRows }